<template>
	<div class="recently-viewed-content">
	  <p v-if="!favs.length" class="c-cp-total">{{$t("favourites.title")}} : {{favs.length }}</p>
	  <ul v-if="favs.length" class="c-favs-actions">
	  	<li>
	  		<!-- Would you like more information on all your saved properties? No problem!<br> -->
		  	<a v-bind:href="trigger" class="c-icon-link">
		  		<icon name="info" />
		  		{{$t("favourites.button.inforequest")}}</a>
	  	</li>
	  	<li v-if="!publictoken">
	  		<!-- You can easily share your favourites with a friend, colleague of family member.<br> -->
		  	<button class="c-favs-action__btn c-icon-link" v-on:click.prevent="fav_share_start">
		  		<icon name="share" />
		  		{{$t("favourites.button.share_start")}}
	  		</button>
	  	</li>
	  	<li v-if="publictoken">
	  		<!-- You can easily share your favourites with a friend, colleague of family member.<br> -->
	  		<button class="c-favs-action__btn c-icon-link" v-on:click.prevent="fav_share_end">
	  			<icon name="close" />
		  		{{$t("favourites.button.share_end")}}
	  		</button>
		  	<button class="c-favs-action__btn c-icon-link"
		  		v-clipboard:copy="shareurl" 
		  		v-clipboard:success="onCopySuccess"
		  		v-clipboard:error="onCopyError"
		  		>
		  		<icon name="bookmarks" />
		  		{{$t("favourites.button.share")}}
	  		</button>
	  	</li>
	  </ul>
	  <ul class="c-mini-cards">
			<property 
    		v-on:favRemove="fav_remove"
    		v-on:favAdd="fav_add"
    		v-for="property in favs" 
    		:key="property.reference" 
    		v-bind="property" 
    		/>
  	</ul>
	</div> 
</template>

<script>
	import Icon from './icon.vue';
	import LFPortal from '../portal/portal.js'
	import Property from './property.vue';
	export default {
		components: {Property, Icon},
	  name: 'favourites',
	  props: ['favs','publictoken'],
	  data () {return {};}, 
	  computed: {
	  	shareurl: function(){
	  		// Creates a search by reference url 
	  		return LFPortal.trigger('publicfavourites') 
	  			+ this.publictoken
	  		;
	  	},
	  	trigger: function(){
	  		return LFPortal.trigger('info') 
	  			+ '?reference='
	  			+ encodeURI(this.favs.map(function(property){return property.reference.toLowerCase();}).join(','))
	  		;
	  	}
	  },
	  methods: {
	  	onCopySuccess(e){
	  		this.$emit('openModal',{
	  			title:this.$t('favourites.copymodal.title'),
         	body:this.$t('favourites.copymodal.bodyauto')
         });
	  		LFPortal.gaevent('FavCopyShareLink');
	  	},
	  	onCopyError(){
	  		this.$emit('openModal',{
         title:this.$t('favourites.copymodal.title'),
         body:this.$t('favourites.copymodal.bodymanual'),
         code:this.shareurl
       	});
	  	},
	  	fav_share_start: function(){
				// console.log("Create share token");
				LFPortal.Favs.share();
			},
			fav_share_end: function(){
				// console.log("Revoke share token");
				LFPortal.Favs.unshare();
			},
			fav_remove: function(reference){
				LFPortal.Favs.remove(reference);
			},
			fav_add: function(reference){
				LFPortal.Favs.add(reference);
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/favourites.vue